/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BaseForm } from './base-form';
import { Directive } from "@angular/core";
import { FormUtils } from "@irian-ro/util-forms";

@Directive()
export abstract class BaseSubmitableForm<T> extends BaseForm<T> {

  protected constructor() {
    super();
  }

  submitForm(): T {
    FormUtils.markAllAsDirty(this.form);
    const formValue = this.getFormValue();
    if (this.form?.valid) {
      return this.formValidSubmit(formValue);
    }
    return this.formInvalidSubmit(formValue);
  }

  protected formValidSubmit(formValue: T) {
    return formValue;
  }

  protected formInvalidSubmit(formValue: T) {
    return null;
  }
}
